import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Layout, Title, Pagination } from 'common/components/layout';
import {
  concatUrlString,
  pageFromQuery,
  urlPushQuery,
  queryStringFromProps
} from 'common/helpers/searchHelper';
import SubMenu from 'profile/common/SubMenu';
import CreditCardDisplay from 'profile/creditCard/CreditCardDisplay';
import { listClubMemberships } from 'redux/clubMemberships/actions';
import { getActiveClubMemberships } from 'redux/clubMemberships/reducers';
import {
  listCustomerCreditCards,
  resetCustomerCreditCardQuery
} from 'redux/customerCreditCards/actions';

import ClubCreditCard from './components/ClubCreditCard';
import DefaultCreditCard from './components/DefaultCreditCard';

class CreditCardList extends Component {
  componentDidMount() {
    const { props } = this;
    props.resetCustomerCreditCardQuery();
    const urlString = queryStringFromProps(props);
    props.listCustomerCreditCards(urlString);
    props.listClubMemberships();
  }

  search = (page) => {
    const { props } = this;
    props.resetCustomerCreditCardQuery();
    const urlString = concatUrlString(page);
    props.listCustomerCreditCards(urlString);
    props.history.push(urlPushQuery('/profile/credit-card', urlString));
  };

  render() {
    const { location, settings, customerCreditCards } = this.props;
    const { activeClubMemberships } = this.props;

    const page = pageFromQuery(location.search);
    if (
      !settings.data ||
      !customerCreditCards.data ||
      customerCreditCards.query === null
    ) {
      return (
        <Layout title="Credit Cards" loading>
          <Title>Your Account</Title>
          <SubMenu />
        </Layout>
      );
    }

    const displayArray = arrayOf2(customerCreditCards.query);
    return (
      <Layout title="Credit Cards">
        <Title>Your Account</Title>
        <SubMenu />

        <div className="c7-account__credit-cards">
          <h2>Credit Cards</h2>

          {displayArray.map((innerArray) => (
            <div key={innerArray[0]} className="c7-account-row">
              {innerArray.map((creditCardId) => {
                const creditCard = customerCreditCards.data[creditCardId];
                return (
                  <div key={creditCard.id} className="c7-account-tile">
                    <CreditCardDisplay creditCard={creditCard} boldName />
                    <br />
                    <DefaultCreditCard
                      creditCard={creditCard}
                      creditCardCount={customerCreditCards.query.length}
                    />
                    <ClubCreditCard
                      creditCard={creditCard}
                      activeClubMemberships={activeClubMemberships}
                    />
                    <Link
                      to={`/profile/credit-card/${creditCard.id}`}
                      className="c7-button-alt-small"
                    >
                      Edit
                    </Link>
                  </div>
                );
              })}
            </div>
          ))}

          <Pagination
            totalRecords={customerCreditCards.recordCount}
            page={page || 1}
            search={this.search}
          />
          <div className="c7-account-row c7-account-row--add">
            <Link to="/profile/credit-card/add" className="c7-button-small">
              Add a new card
            </Link>
          </div>
        </div>
      </Layout>
    );
  }
}

const arrayOf2 = (array) => {
  const arrayOutput = [];
  let innerArray = [];
  if (!array) {
    return arrayOutput;
  }
  array.forEach((element, index) => {
    innerArray.push(element);
    if ((index + 1) % 2 === 0) {
      arrayOutput.push(innerArray);
      innerArray = [];
    }
  });
  if (innerArray.length > 0) {
    arrayOutput.push(innerArray);
  }
  return arrayOutput;
};

const mapStateToProps = (state) => ({
  customerCreditCards: state.customerCreditCard,
  settings: state.setting,
  activeClubMemberships: getActiveClubMemberships(state.clubMembership)
});

export default connect(mapStateToProps, {
  listCustomerCreditCards,
  resetCustomerCreditCardQuery,
  listClubMemberships
})(CreditCardList);
